export default __webpack_public_path__ + "static/1238-8b26160d46d65721112d894233a318b9.gif";